export const SUCCESS_PRESENTATION = "SUCCESS_PRESENTATION";
export const LOADING_PRESENTATION = "LOADING_PRESENTATION";
